module.exports = __webpack_public_path__ + "img/mamelodi-sundowns.5a2906f1.png";